import { render } from 'react-dom';
import React from 'react';
import "@babel/polyfill";
import App from './src/App';
import './src/stylesheets/main.scss';
//import * as serviceWorker from './serviceWorker';

render(<App />, document.getElementById('app'));
//serviceWorker.register();